module.exports = __webpack_public_path__ + "media/images/icons/user-f580b8d8ef63f9365f0f4aec0304b448.svg";